export default __webpack_public_path__ + "static/media/dp_Commision.2f38aed1.svg";